export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14473.fbb53b4d.jpg";